/**
 * WPA 商店 API 請求標頭：對應後端 CommerceLocaleHelper.ResolveWpaUiLocale（X-WPA-Locale）。
 * LanguageContext 的 currentLanguage 為 zh-TC | zh-SC | en。
 */
export function wpaCommerceHeaders(token, uiLocale) {
  const headers = { Authorization: `Bearer ${token}` };
  if (uiLocale) headers['X-WPA-Locale'] = uiLocale;
  return headers;
}

/** 商品／集合 API 回傳的顯示名稱（後端 displayName 依語系解析） */
export function wpaLocalizedName(entity) {
  if (!entity) return '';
  const d = entity.displayName != null ? String(entity.displayName).trim() : '';
  if (d) return d;
  return entity.name != null ? String(entity.name) : '';
}

/** 客戶主檔 customer_status 僅 Active 可下單／加購物車。 */
export function isWpaCommerceCustomerOrderAllowed(customer) {
  if (!customer) return false;
  const raw = customer.customerStatus ?? customer.customer_status ?? 'Active';
  return String(raw).trim().toLowerCase() === 'active';
}

/** 依客戶主檔或 API 回傳組出帳戶暫停提示（與 formatWpaCommerceApiError 一致）。 */
export function buildWpaCustomerSuspendedBlock(source, t) {
  const dash = t('wpa.common.emDash');
  const sales =
    source?.salesmanName != null && String(source.salesmanName).trim() !== ''
      ? String(source.salesmanName).trim()
      : source?.salesman_name != null && String(source.salesman_name).trim() !== ''
        ? String(source.salesman_name).trim()
        : dash;
  const scm =
    source?.salesmanCode != null && String(source.salesmanCode).trim() !== ''
      ? String(source.salesmanCode).trim()
      : source?.salesman_code != null && String(source.salesman_code).trim() !== ''
        ? String(source.salesman_code).trim()
        : dash;
  const wa =
    source?.salesmanWhatsapp != null && String(source.salesmanWhatsapp).trim() !== ''
      ? String(source.salesmanWhatsapp).trim()
      : source?.salesman_whatsapp != null && String(source.salesman_whatsapp).trim() !== ''
        ? String(source.salesman_whatsapp).trim()
        : dash;
  return t('wpa.common.customerSuspendedBlock', { sales, code: scm, whatsapp: wa });
}

/**
 * WPA commerce API 錯誤轉為可顯示字串；CUSTOMER_SUSPENDED 依語系與業務員主檔組版。
 * @param {Response} res
 * @param {object} json
 * @param {(key: string, params?: object) => string} t useLanguage().t
 */
export function formatWpaCommerceApiError(res, json, t) {
  const code = json?.code;
  if (code === 'CUSTOMER_SUSPENDED' || json?.errorCode === 'C') {
    return buildWpaCustomerSuspendedBlock(json, t);
  }
  if (json?.message) return json.message;
  if (json?.title) return json.title;
  if (json?.errors && typeof json.errors === 'object') {
    const vals = Object.values(json.errors).flat();
    if (vals.length && vals[0]) return String(vals[0]);
  }
  if (res.status === 403) return t('wpa.common.forbiddenAction');
  return t('wpa.common.requestFailedStatus', { status: res.status });
}
